import React, { Component } from 'react'
import { Provider } from 'react-redux'
import Calculator from './components/Calculator'
import { store } from './store'
import { FETCH_RATESHEET } from './actions'

class App extends Component {
  componentDidMount() {
    store.dispatch({
      type: FETCH_RATESHEET,
    })
  }

  render() {
    return (
      <Provider store={store}>
        <div className="App">
          <Calculator />
        </div>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js